/* eslint-disable import/prefer-default-export */
import React from 'react';

import Toast from 'react-bootstrap/Toast';

import Button from 'react-bootstrap/Button';

import { DatetimePicker } from '@appblocks/frontend/client/Components/DeviceDashboard/TimeComponents';

import {
    timezones,
    CMD_VARIABLE,
    CMD_TABLE,
    CMD_SYSTEM,
    CMD_VARIABLE_ACTION,
    CMD_TABLE_ACTION,
    CMD_SYSTEM_ACTION,
} from '@appblocks/frontend/client/Components/DeviceDashboard/constants';

/* FRONTEND_START_MARKER */

const InformationElement = ({
    label,
    action,
    spanSelectAll,
    value,
    children,
}) => {
    const labelStyle = {
        fontWeight: 'bold',
    };

    return (
        <div className="row mb-2">
            <div className="col-md-2">
                <span style={labelStyle}>{label}</span>
            </div>
            {
                value && (
                    <div className="col-md-6">
                        {spanSelectAll ? <SpanSelectAll value={value} />
                            : <span>{value}</span>}
                    </div>
                )
            }
            {
                children && (
                    <div className="col-md-6">
                        {children}
                    </div>
                )
            }
            <div className="col-md-2">
                {action}
            </div>
        </div>
    );
};

const SpanSelectAll = ({ value }) => {
    return (
        <span style={{
            userSelect: 'all',
        }}
        >
            {value}
        </span>
    );
};

const Timestamp = ({
    value, selected, setSnackbarOn, update, minutesOffset, runCommand,
}) => {
    const [isEditing, setIsEditing] = React.useState(false);
    const [newDate, setNewDate] = React.useState(value);

    const handleChange = (date) => {
        setNewDate(date);
    };
    const updateTime = () => {
        const timestamp = newDate;
        runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.UPDATE_TIME, {
            t: timestamp,
        })
            .then(
                (result) => {
                    setSnackbarOn(true);
                    update();
                    setIsEditing(false);
                },
                (error) => {
                    alert('error sending', error);
                    console.error(error);
                },
            );
    };

    const getLocalTime = () => {
        const value = Date.parse(new Date());
        setNewDate(value / 1000);
    };

    const action = isEditing
        ? (
            <>
                <Button onClick={updateTime}>Update</Button>
                &nbsp;
                <Button onClick={getLocalTime} variant="info">Now</Button>
                &nbsp;
                <Button onClick={() => setIsEditing(false)} variant="secondary">Cancel</Button>
            </>
        )
        : (
            <Button onClick={() => setIsEditing(true)}>Change</Button>
        );

    const Datetime = (
        <DatetimePicker
            edit={isEditing}
            time={isEditing ? newDate : value}
            handleChange={handleChange}
        />
    );

    return (
        <InformationElement label="Device time" action={action}>
            {
                isEditing ? (
                    <div className="col-sm-12">
                        {Datetime}
                    </div>
                ) : Datetime
            }
        </InformationElement>
    );
};

const UTC = ({
    value, setSnackbarOn, selected, setSelected, update, minutesOffset, runCommand,
}) => {
    const updateTz = () => {
        const timestamp = Date.parse(new Date()) / 1000;
        runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.UPDATE_TIMEZONE, {
            tz: selected,
            t: timestamp,
        })
            .then(
                (result) => {
                    // alert(result);
                    setSnackbarOn(true);
                    update();
                },
                (error) => {
                    alert('error sending', error);
                    console.error(error);
                },
            );
    };


    return (
        <InformationElement
            label="Timezone"
        >
            <div className="col-sm-4">
                <span>
                    {timezones.find(option => option.value === value).name}
                </span>
            </div>
        </InformationElement>
    );
};

const infoElements = [
    'appName',
    'appVersion',
    'firmwareVersion',
    'ip',
    'mac',
    'wifiOn',
    'wlnip',
    'wlnmac',
    'bootTime',
    'timezone',
    'time',
];

const Information = ({
    update, refresh, refreshing, lastAction, runCommand, deviceStatus,
}) => {
    const [snackbarOn, setSnackbarOn] = React.useState(false);
    const [selectedTZOffset, setSelectedTZOffset] = React.useState(deviceStatus.timezone);
    const [uptime, setUptime] = React.useState();
    const [time, setTime] = React.useState(Number(deviceStatus.time));

    React.useEffect(() => {
        const interval = setInterval(
            () => {
                setUptime((uptime) => {
                    uptime.setSeconds(uptime.getSeconds() + 1);
                    const clonedDate = new Date(uptime.getTime());
                    return clonedDate;
                });
                setTime(time => time + 1);
            },
            1000,
        );
        return () => {
            clearInterval(interval);
        };
    }, []);

    React.useEffect(() => {
        setTime(Number(deviceStatus.time));
    }, [deviceStatus.time]);

    React.useEffect(() => {
        if (Number.isNaN(Number(deviceStatus.bootTime))) {
            setUptime(new Date(Date.now() - Number(new Date(deviceStatus.bootTime))));
            return;
        }
        setUptime(new Date(Date.now() - deviceStatus.bootTime * 1000));
    }, [deviceStatus.bootTime]);

    return (
        <>
            {
                infoElements.map((name) => {
                    if (!deviceStatus[name]) {
                        return null;
                    }
                    switch (name) {
                        case 'appName':
                            return (
                                <InformationElement
                                    label="Application Name"
                                    key={name}
                                    value={`${deviceStatus[name]}`}
                                    spanSelectAll
                                />
                            );
                        case 'appVersion':
                            return (
                                <InformationElement
                                    label="Application Version"
                                    key={name}
                                    value={deviceStatus[name]}
                                    spanSelectAll
                                />
                            );
                        case 'firmwareVersion':
                            return (
                                <InformationElement
                                    label="Firmware Version"
                                    key={name}
                                    value={deviceStatus[name]}
                                    spanSelectAll
                                />
                            );
                        case 'ip':
                            return (
                                <InformationElement
                                    label="Ethernet IP"
                                    key={name}
                                    value={deviceStatus[name]}
                                    spanSelectAll
                                />
                            );
                        case 'mac':
                            return (
                                <InformationElement
                                    label="Ethernet MAC"
                                    key={name}
                                    value={deviceStatus[name]}
                                    spanSelectAll
                                />
                            );
                        case 'wifiOn':
                            return (
                                <InformationElement
                                    label="Wifi Status"
                                    key={name}
                                    value={deviceStatus[name] === '1' ? 'On' : 'Off'}
                                />
                            );
                        case 'wlnip':
                            return (
                                <InformationElement
                                    label="Wi-Fi IP"
                                    key={name}
                                    value={deviceStatus[name]}
                                    spanSelectAll
                                />
                            );
                        case 'wlnmac':
                            return (
                                <InformationElement
                                    label="Wi-Fi MAC"
                                    key={name}
                                    value={deviceStatus[name]}
                                    spanSelectAll
                                />
                            );
                        case 'bootTime':
                            return (
                                <InformationElement
                                    label="Boot Time"
                                    key={name}
                                    value={uptime ? uptime.toISOString().substr(11, 8) : 'N/A'}
                                />
                            );
                        case 'time':
                            return (
                                <Timestamp
                                    value={time}
                                    key={name}
                                    selected={selectedTZOffset}
                                    setSnackbarOn={setSnackbarOn}
                                    update={update}
                                    runCommand={runCommand}
                                />
                            );
                        case 'timezone':
                            return (
                                <UTC
                                    value={deviceStatus[name]}
                                    key={name}
                                    setSnackbarOn={setSnackbarOn}
                                    selected={selectedTZOffset}
                                    setSelected={setSelectedTZOffset}
                                    update={update}
                                    runCommand={runCommand}
                                />
                            );
                        default:
                            return null;
                    }
                })
            }
            <Button
                onClick={() => {
                    refresh();
                    setSnackbarOn(true);
                }}
                variant="secondary"
                disabled={refreshing}
            >
                Refresh
            </Button>
            <Toast
                show={snackbarOn}
                onClose={() => setSnackbarOn(false)}
                delay={3000}
                autohide
                className="text-white"
                bg="dark"
                style={{
                    position: 'absolute',
                    bottom: '3rem',
                    right: '3rem',
                }}
            >
                <Toast.Body>{lastAction}</Toast.Body>
            </Toast>
        </>
    );
};


export default Information;
